// @flow
import React from 'react';
import { DeleteMyAccount as DeleteMyAccountView } from '@views';

const DeleteMyAccount = () => (
  <DeleteMyAccountView />
);

export default DeleteMyAccount;
